<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Frontmatter">
<p class="non_para_1_ts">Information about External Hyperlinks in this ebook</p>
<p class="non_para_ts">Please note that the endnotes in this ebook may contain hyperlinks to external websites as part of bibliographic citations. These hyperlinks have not been activated by the publisher, who cannot verify the accuracy of these links beyond the date of publication</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310296065_Frontmatter1.vue?a8f6cdc0